import { types, getParent, flow } from 'mobx-state-tree';
import LoggedinUser from './LoggedinUser';
import { Agent } from '../stores/agent';

export const UserProps = types
    .model('UserProps', {
        id: types.string,
        email: types.string,
        mobilenumber: types.string,
        phonenumber: types.string,
        extension: types.string,
        tenantid: types.number,
        loginname: types.string,
        password: types.string,
        errors: types.string,
    })
    .views(self => ({
        get loggedinUser() {
            return getParent(self);
        },
    }))
    .actions(self => ({
        setLoginName(adr: string) {
            self.loginname = adr;
        },
        setPassword(pwd: string) {
            self.password = pwd;
        },
        setErrors(err: string) {
            self.errors = err;
        },
        setProps(data) {
            self.id = data.properties.id;
            self.email = data.properties.email;
            self.mobilenumber = data.properties.mobilenumber;
            self.phonenumber = data.properties.phonenumber;
            self.extension = data.properties.extension;
            self.tenantid = data.properties.tenantid;
            self.errors = '';            
        },
        clearProps() {
            self.loginname = '';
            self.password = '';
            self.id = '';
            self.email = '';
            self.mobilenumber = '';
            self.phonenumber = '';
            self.extension = '';
            self.tenantid = 0;
            self.errors = '';            
        }

        // login() {
        //     // Fake login
        //     if (self.email === 'berit@advoco.se') {
        //         self.id = 'bebe@advoco.arcstel.netpbx5.net';
        //         self.loggedinUser.setUser('Berit', 'Beritsson');
        //         self.email = 'berit@advoco.se';
        //         self.phonenumber = '087494700';
        //         self.extension = '4796';
        //         self.mobilenumber = '0701114567';
        //         self.password = '';
        //         self.errors = '';
                
        //         self.loggedinUser.subscriptions.clear();
        //         self.loggedinUser.subscriptions.add({
        //             'number': '0701114567',
        //             'name': 'Tellit to Go 5GB',
        //             'surfAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'initData': 5,
        //                     'usedData': 2,
        //                     'isCapped': false,
        //                     'isLoading': false
        //                 },
        //             'msgAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'sentSMS': 12,
        //                     'sentMMS': 2
        //                 },
        //             'callsAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'madeNationalCalls': 25,
        //                     'nationalCallTime': '08:18:02',
        //                     'madeInternationalCalls': 0,
        //                     'internationalCallTime': '00:00:00'
        //                 },
        //             'properties':
        //                 {
        //                     'PUKcode': '11122233',
        //                     'SIMcardNumber': '1112223334445556667',
        //                     'description':'Med Tellit to Go kan du ringa inom landet, skicka SMS och MMS och surfa.',                            
        //                     'extra1': 'Tellit to Go finns med flera olika surfpaket - 1GB, 5GB, 10GB, 30GB eller 100GB surf.',
        //                     'extra2': 'Samtal till utlandet samt betalsamtal ingår inte i abonnemanget.'
        //                 }          
        //             },
        //         );
        //         self.loggedinUser.subscriptions.setSelectedSubscription(self.loggedinUser.subscriptions.items[0].number);
                               
        //     }
        //     else if (self.email === 'sven@advoco.se') {
        //         self.id = 'svsv@advoco.arcstel.netpbx5.net';
        //         self.loggedinUser.setUser('Sven', 'Svensson');
        //         self.email = 'sven@advoco.se';
        //         self.phonenumber = '087494701';
        //         self.extension = '4797';
        //         self.mobilenumber = '0702224567';
        //         self.errors = '';
        //         self.password = '';
                
        //         self.loggedinUser.subscriptions.clear();                
        //         self.loggedinUser.subscriptions.add({
        //             'number': '0702224567',
        //             'name': 'Tellit to Go 5GB',
        //             'surfAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'initData': 5,
        //                     'usedData': 3,
        //                     'isCapped': false,
        //                     'isLoading': false
        //                 }, 
        //             'msgAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'sentSMS': 48,
        //                     'sentMMS': 18
        //                 },                   
        //             'callsAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'madeNationalCalls': 10,
        //                     'nationalCallTime': '04:20:02',
        //                     'madeInternationalCalls': 2,
        //                     'internationalCallTime': '00:12:14'
        //                 },
        //             'properties':
        //                 {
        //                     'PUKcode': '44455560',
        //                     'SIMcardNumber': '4445556667778889990',
        //                     'description':'Med Tellit to Go kan du ringa inom landet, skicka SMS och MMS och surfa.',                            
        //                     'extra1': 'Tellit to Go finns med flera olika surfpaket - 1GB, 5GB, 10GB, 30GB eller 100GB surf.',
        //                     'extra2': 'Samtal till utlandet samt betalsamtal ingår inte i abonnemanget.'
        //                 }
        //             },
        //         );                
        //         self.loggedinUser.subscriptions.add({
        //             'number': '0703334567',
        //             'name': 'Tellit to Go 30GB',
        //             'surfAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'initData': 30,
        //                     'usedData': 13,
        //                     'isCapped': false,
        //                     'isLoading': false
        //                 },
        //             'msgAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'sentSMS': 12,
        //                     'sentMMS': 4
        //                 }, 
        //             'callsAmount':
        //                 {
        //                     'resetDate': '20180228',
        //                     'madeNationalCalls': 20,
        //                     'nationalCallTime': '05:40:10',
        //                     'madeInternationalCalls': 5,
        //                     'internationalCallTime': '00:52:15'
        //                 },                    
        //             'properties':
        //                 {
        //                     'PUKcode': '44455561',
        //                     'SIMcardNumber': '4445556667778889991',
        //                     'description':'Med Tellit to Go kan du ringa inom landet, skicka SMS och MMS och surfa.',                            
        //                     'extra1': 'Tellit to Go finns med flera olika surfpaket - 1GB, 5GB, 10GB, 30GB eller 100GB surf.',
        //                     'extra2': 'Samtal till utlandet samt betalsamtal ingår inte i abonnemanget.'
        //                 }
        //             },
        //         );
        //         self.loggedinUser.subscriptions.setSelectedSubscription(self.loggedinUser.subscriptions.items[0].number);
        //     }          
        //     else {
        //         self.loggedinUser.clearUser();
        //         self.errors = 'Felaktig inloggning';
        //     }
        //},

        // logout() {
        //     self.password = '';
        //     self.loggedinUser.clearUser();
        //     self.id = '';
        //     self.email = '';
        //     self.phonenumber = '';
        //     self.extension = '';
        //     self.mobilenumber = '';
        //     self.loginname = '';
        // }
    })

    );

export default UserProps;



// WEBPACK FOOTER //
// ./src/models/UserProps.ts